import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Highlighter from 'react-highlight-words';
import classNames from 'classnames';
import './Result.scss';
import { Link } from 'react-router-dom';

export default class Result extends Component {
    static propTypes = {
        firstRowExtraSpacing: PropTypes.bool,
        inputValue: PropTypes.string,
        onSelectResult: PropTypes.func,
        resultLink: PropTypes.string.isRequired,
        textRows: PropTypes.arrayOf(PropTypes.string).isRequired
    };

    static defaultProps = {
        inputValue: '',
        thirdRowText: '',
        fourthRowText: ''
    };

    constructor(props) {
        super(props);

        this.renderHighlighter = this.renderHighlighter.bind(this);
    }

    renderHighlighter(text, isFirstRow, key) {
        if (text) {
            return (<Highlighter
                key={key}
                className={classNames('result-row', {
                    'space-words': this.props.firstRowExtraSpacing && isFirstRow
                })}
                highlightClassName="search-match"
                highlightTag="span"
                searchWords={this.props.inputValue.split(' ')}
                textToHighlight={text}
            />);
        }
    }

    render() {
        return (
            <Link className="emvio-search-result" to={this.props.resultLink} onClick={this.props.onSelectResult}>
                {this.props.textRows.map((textRow, i) => {
                    const isFirstRow = i === 0;

                    return this.renderHighlighter(textRow, isFirstRow, i);
                })}
            </Link>
        );
    }
}
